<template>
  <j-modal
    ref="jmodal"
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :ok-disabled="true"
    @setInnerFullscreen="setInnerFullscreen"
    :fullscreen="true"
    :cancelText="language['common.closeButton']">
<!--    <cms-content-tbl-list-simp ref="realForm" :colid="this.colid"></cms-content-tbl-list-simp>-->
    <cms-content-tbl-list ref="realForm" :colid="this.colid" v-if="visible" :onlyView="onlyView"></cms-content-tbl-list>
    <template slot="footer">
      <a-button @click="handleCancel">关闭</a-button>
    </template>
  </j-modal>
</template>

<script>

  import CmsContentTblForm from './CmsContentTblForm'
  import CmsContentTblList from '@views/hhemp/cms/CmsContentTblList'
  // import CmsContentTblListSimp from './CmsContentTblListSimp'


  export default {
    name: 'CmsContentTblListModal',
    components: {
      CmsContentTblForm,
      //CmsContentTblListSimp,
      CmsContentTblList
    },
    data () {
      return {
        title:'内容列表',
        width:1200,
        visible: false,
        disableSubmit: true,
        colid: '',
        onlyView: false,
        innerFullscreen:true
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      }
    },
    methods: {
      setInnerFullscreen(val) {
        this.innerFullscreen = val
      },
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      listdetail (colid,onlyView) {
        this.visible = true;
        this.colid = colid;
        this.disableSubmit = true;
        if(onlyView&&typeof(onlyView)!='undefined'){
          //调用内容管理列表是否只有查看权限
          this.onlyView=true;
        }

      },
    }
  }
</script>